import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { getChapterById } from '../../../../features/state/StateChapter-slice';
import { getTitleById } from '../../../../features/state/StateTitle-slice';
import { getFilingSupportingDocs, updateFiling } from '../../../../features/state/StateFiling-slice';

export const useTaskPreviewController = (filing: any) => {
  const dispatch = useAppDispatch();
  const chapter = useAppSelector((state) => state.chapters.chapter);
  const [tabSelected, setTabSelected] = useState<string>('Filing Details');

  useEffect(() => {
    dispatch(getChapterById(filing.chapterId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filing]);

  const menuItems = [{ label: 'Filing Details' }, { label: 'Files' }];

  const selectTab = async (event: any) => {
    setTabSelected(event.text);
  };

  const parseUTCDate = (date: any) => {
    return new Date(date[date.length - 1] === 'Z' ? date : date.concat('Z')).toLocaleString();
  }

  return {
    // functions
    selectTab,
    parseUTCDate,
    // redux
    chapter,
    // state
    menuItems,
    tabSelected,
  };
};
